module.exports = __webpack_public_path__ + "img/aboutus_fd.b93006ea.png";